import { Cartesian3 } from "cesium";
import Delaunator from "delaunator";
export function createPointCloudGeom(input) {
    const upDirection = new Cartesian3(0, 0, 1);
    //transforming the vertex buffer data into local transformation
    const cartesians = Cartesian3.unpackArray(input.vertexBuffer);
    const geom = {
        indices: input.indexBuffer,
        vertices: input.vertexBuffer,
        upDirection: upDirection,
    };
    if (!geom.indices || geom.indices.length === 0) {
        const verticesWithNoZ = [];
        for (const point of cartesians) {
            verticesWithNoZ.push(point.x, point.y);
        }
        const delaunay = new Delaunator(verticesWithNoZ);
        geom.indices = [...delaunay.triangles];
    }
    return geom;
}
//# sourceMappingURL=utils.js.map